import React, { useEffect, useState } from 'react';
import styles from './dashboard-panel.module.css';
import Sidebar from '../sidebar/sidebar';
import { Route, Routes } from 'react-router-dom';

// Containers
import Home from '../../containers/home/home';
import EventList from '../../containers/event/event-list';
import EventCreate from '../../containers/event/event-create';
import EventEditFollow from '../../containers/event/event-edit-follow';
import DiaryListContainer from '../../containers/diary/diary-list';
import DiaryClassroomList from '../../containers/diary/diary-classroom-list';
import DiaryClassroomHistory from '../../containers/diary/diary-classroom-history';
import DiaryFormCreate from '../../containers/diary/diary-form-create';
import DiaryGroupEdit from '../../containers/diary/diary-group-edit';
import DiaryFollow from '../../containers/diary/diary-follow';
import DiaryRegisterAbsences from '../../containers/diary/diary-register-absences';
import DiaryJustifyAbsences from '../../containers/diary/diary-justify-absences';
import ShowProfile from '../../containers/profile/show-profile';
import AnnouncementList from '../../containers/announcement/announcement-list';
import AnnouncementCreate from '../../containers/announcement/announcement-create';
import AnnouncementEditFollow from '../../containers/announcement/announcement-edit-follow';
import ActivityList from '../../containers/activity/activity-list';
import ActivityCreate from '../../containers/activity/activity-create';
import ActivityEditFollow from '../../containers/activity/activity-edit-follow';
import GalleryList from '../../containers/gallery/gallery-list';
import GalleryCreate from '../../containers/gallery/gallery-create';
import GalleryEditFollow from '../../containers/gallery/gallery-edit-follow';
// import ManagementHome from '../../containers/management/management-home';
import NoticeBoardList from '../../containers/notice-board/notice-board-list';
import NoticeBoardEdit from '../../containers/notice-board/notice-board-edit';
import NoticeBoardCreate from '../../containers/notice-board/notice-board-create';
import EmployeeCreate from  '../../containers/employee/employee-create';
import EmployeeEdit from  '../../containers/employee/employee-edit';
import ChatList from '../../containers/chat/chat-list';
import ManagementUsers from '../../containers/management/management-users';
import ManagementClassroom from '../../containers/management/management-classroom';
import ManagementStudent from '../../containers/management/management-student';

// Components
import Loading from '../loading/loading';
import ErrorComponent from '../error/error';

// Services
import SchoolService from '../../services/school-service';
import StorageService from '../../services/storage-service';
import GalleryEdit from '../../containers/gallery/gallery-edit';
import ChatDetail from '../../containers/chat/chat-detail';
import ReportList from '../../containers/report/report-list';
import ReportDetail from '../../containers/report/report-detail';

function DashboardPanel() {
  const schoolService = new SchoolService();
  const storageService = new StorageService();

  const [error, setError] = useState(false);
  const [school, setSchool] = useState(null);
  useEffect(() => {
    const authInfo = storageService.getAuthInfo();
    if (!school && authInfo) {
      const schoolId = authInfo.employee.schoolId;
      schoolService
        .getSchoolById(schoolId)
        .then((school) => {
          setSchool(school);
        })
        .catch(() => setError(true));
    }
  }, [school, schoolService, storageService]);

  if (error) return <ErrorComponent type='general' />;

  if (!school) return <Loading type='general' />;

  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapperContent}>
        <aside className={styles.aside}>
          <Sidebar school={school} />
        </aside>
        <article className={styles.main}>
          <Routes>
            <Route path='/eventos/listar' element={<EventList />} />
            <Route path='/eventos/criar' element={<EventCreate />} />
            <Route path='/eventos/:eventId' element={<EventEditFollow />} />

            <Route path='/diarios/listar' element={<DiaryListContainer />} />
            <Route path='/diarios/turma/:classroomUuid' element={<DiaryClassroomList />} />
            <Route path='/diarios/turma/:classroomUuid/preencher' element={<DiaryFormCreate />} />
            <Route path='/diarios/turma/:classroomUuid/grupo/:groupId' element={<DiaryGroupEdit />} />
            <Route path='/diarios/turma/:classroomUuid/historico' element={<DiaryClassroomHistory />} />
            <Route path='/diarios/turma/:classroomUuid/aluno/:studentUuid' element={<DiaryFollow />} />
            <Route path='/diarios/turma/:classroomUuid/registrar-faltas' element={<DiaryRegisterAbsences />} />
            <Route path='/diarios/turma/:classroomUuid/justificar-faltas' element={<DiaryJustifyAbsences />} />

            <Route path='/comunicados/listar' element={<AnnouncementList />} />
            <Route path='/comunicados/criar' element={<AnnouncementCreate />} />
            <Route path='/comunicados/:announcementId' element={<AnnouncementEditFollow />} />

            <Route path='/atividades/listar' element={<ActivityList />} />
            <Route path='/atividades/criar' element={<ActivityCreate />} />
            <Route path='/atividades/:activityId' element={<ActivityEditFollow />} />

            <Route path='/galerias/listar' element={<GalleryList />} />
            <Route path='/galerias/criar' element={<GalleryCreate />} />
            <Route path='/galerias/:galleryId/editar' element={<GalleryEdit />} />
            <Route path='/galerias/:galleryId' element={<GalleryEditFollow />} />

            <Route path='/mural/listar' element={<NoticeBoardList />} />
            <Route path='/mural/criar' element={<NoticeBoardCreate />} />
            <Route path='/mural/:noticeBoardId' element={<NoticeBoardEdit />} />

            <Route path='/funcionarios/criar' element={<EmployeeCreate />} />
            <Route path='/funcionarios/:employeeId' element={<EmployeeEdit />} />

            <Route path='/mensagens/listar' element={<ChatList />} />
            <Route path='/mensagens/:chatId' element={<ChatDetail />} />

            <Route path='/relatorios/listar' element={<ReportList />} />
            <Route path='/relatorios/:reportId' element={<ReportDetail />} />

            {/* TODO: Remover quando houver mais estatisticas para o painel */}
            {/* <Route path='/gerenciar' element={<ManagementHome />} /> */}
            <Route path='/gerenciar' element={<ManagementUsers />} />
            <Route path='/gerenciar/turma/:classroomId' element={<ManagementClassroom />} />
            <Route path='/gerenciar/turma/:classroomId/aluno/criar' element={<ManagementStudent />} />
            <Route path='/gerenciar/aluno/:studentId' element={<ManagementStudent />} />

            <Route path='/perfil' element={<ShowProfile />} />

            <Route path='/' element={<Home />} />
          </Routes>
        </article>
      </div>
    </div>
  );
}

export default DashboardPanel;
